"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),require("./es6Promise"),require("./objectAssign"),require("./objectKeys");


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@3.0.14@dingtalk-jsapi/lib/polyfills/index.js
// module id = 1142
// module chunks = 106